import { observer } from 'mobx-react-lite';
import { Button, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import loc from 'owa-localize';
import { OwaModalProps } from 'owa-modal/lib/showModal';
import * as React from 'react';
import { cancelInsertLinks } from '../actions/internalActions';
import { LinkPluginViewStore } from '../store/schema/LinkPluginViewStore';
import { getStore } from '../store/store';
import { InsertLinksNotActive } from '../utils/constants';
import { Cancel, SharingLinks, SharingLinksText } from '../utils/linkPluginString.locstring.json';

const styles = require('./insertLinksModal.scss');

export interface InsertLinksModalProps extends OwaModalProps<{}> {}

export const InsertLinksModal = observer(function InsertLinksModal(props: InsertLinksModalProps) {
    const onDismissHandler = React.useCallback((evt: React.SyntheticEvent<HTMLElement, Event>) => {
        cancelInsertLinks();
        props.onDismiss({});
    }, []);

    const onCancelHandler = React.useCallback((evt: React.MouseEvent<Button, MouseEvent>) => {
        cancelInsertLinks();
        props.onDismiss({});
    }, []);

    const linkPluginViewStore: LinkPluginViewStore = getStore();
    const shouldHide: boolean = linkPluginViewStore.insertLinksTaskId === InsertLinksNotActive;
    return (
        <Dialog
            hidden={shouldHide}
            onDismiss={onDismissHandler}
            dialogContentProps={{
                type: DialogType.normal,
                closeButtonAriaLabel: loc(Cancel),
                title: loc(SharingLinks),
            }}>
            <Spinner size={SpinnerSize.medium} />
            <Label className={styles.label}>{loc(SharingLinksText)}</Label>
            <DialogFooter>
                <DefaultButton
                    className={styles.cancelButton}
                    onClick={onCancelHandler}
                    text={loc(Cancel)}
                />
            </DialogFooter>
        </Dialog>
    );
});
